import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes, SearchTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

const getEmptyState = () => ({searchText: '', params: {}, results: [], isFetching: 0, fetchedAll: false});

const getSanitiseFunction = (searchType) => {
    switch (searchType) {
        case SearchTypes.COURSE_ENROLMENTS:
            return (data) => ({
                ...data,
                userDeleted:  !!Number(data.userDeleted)
            });
        default:
            return null;
    }
};

class SearchStore extends ReduceStore {

    getInitialState() {
        return { [SearchTypes.DEFAULT]: getEmptyState()};
    }

    isFetching(key = SearchTypes.DEFAULT) {
        const stateElement = this.getState()[key];
        return !!stateElement && stateElement.isFetching > 0;
    }

    fetchedAll(key = SearchTypes.DEFAULT) {
        const state = this.getState()[key];
        return state ? state.fetchedAll : null;
    }

    getByKey(key = SearchTypes.DEFAULT) {
        return this.getState()[key];
    }

    getResults(key = SearchTypes.DEFAULT) {
        const state = this.getState()[key];
        return state ? state.results : null;
    }

    reduce(state, action) {
        let key;
        switch (action.type) {
            case ActionTypes.SEARCH_REQUEST:
                key = action.payload.key || SearchTypes.DEFAULT;
                return {
                    ...state,
                    [key]: {
                        ...state[key],
                        isFetching: !!state[key] ? state[key].isFetching + 1 : 1,
                        ...action.payload
                    }
                };

            case ActionTypes.SEARCH_SUCCESS:
                key = action.payload.key || SearchTypes.DEFAULT;
                const stateElement = state[key] || {};
                const clearAll = !action.payload.params || !action.payload.params.page || action.payload.searchText !== stateElement.searchText;
                const sanitise = getSanitiseFunction(key);
                const data = !sanitise ? action.data : action.data.map(sanitise);
                return {
                    ...state,
                    [key]: {
                        isFetching: (stateElement.isFetching || 0) - 1,
                        fetchedAll: data.length === 0,
                        results: clearAll ? data : (!!data.length ? [...stateElement.results, ...data] : stateElement.results),
                        ...action.payload
                    }
                };

            case ActionTypes.SEARCH_FAILURE:
                key = action.payload.key || SearchTypes.DEFAULT;
                return {
                    ...state,
                    [key] : {
                        ...(action.payload.searchText !== state[key].searchText) ? getEmptyState() : state[key],
                        ...action.payload
                    }
                };

            default:
                return state;
        }
    }
}

export default new SearchStore(CentricDispatcher);
